import { render, staticRenderFns } from "./FiledRecord.vue?vue&type=template&id=16ea90d7&scoped=true&"
import script from "./FiledRecord.vue?vue&type=script&lang=js&"
export * from "./FiledRecord.vue?vue&type=script&lang=js&"
import style0 from "./FiledRecord.vue?vue&type=style&index=0&id=16ea90d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea90d7",
  null
  
)

export default component.exports